/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Prompt_LabelInputs */

const en_road_dude_prompt_label = /** @type {(inputs: Road_Dude_Prompt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SCENE PROMPT`)
};

const zh_road_dude_prompt_label = /** @type {(inputs: Road_Dude_Prompt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场景提示词`)
};

/**
* | output |
* | --- |
* | "SCENE PROMPT" |
*
* @param {Road_Dude_Prompt_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_prompt_label = /** @type {((inputs?: Road_Dude_Prompt_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Prompt_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_prompt_label(inputs)
	return zh_road_dude_prompt_label(inputs)
});
export { road_dude_prompt_label as "road_dude.prompt.label" }